import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { BusinessFunctionService } from "../../services/businessfunction.service";
import { AuthService } from "../../services/auth.service";
import { IBusinessFunction } from "../../interfaces/ibusinessfunction";
import { ToastrService } from "ngx-toastr";
import { IUser } from "../../interfaces/ilogin";
import { AppUserService } from "../../services/appuser.service";
import { RoutesService } from "../../services/routes.service";
import { Title } from "@angular/platform-browser";

@Component({
    selector: "businessfunctionselector",
    templateUrl: "./businessfunctionselector.component.html",
    standalone: false
})
export class BusinessFunctionSelectorComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    businessFunctions!: IBusinessFunction[];
    businessFunctionSelected: number | null = null;
    usersName!: string;
    userIsAuthed: boolean = false;
    constructor(private businessFunctionService: BusinessFunctionService,
        private authService: AuthService,
        private appUserService: AppUserService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toastr: ToastrService,
        private routesService: RoutesService,
        private titleService: Title) {
        this.authService.businessFunction = null;
        this.businessFunctions = this.activatedRoute.snapshot.data['businessFunctions'] as IBusinessFunction[];
        this.titleService.setTitle("BusinessFunctionSelector");
        this.routesService.currentPageTitle.next('Business Function Selector Screen');
    }

    ngOnInit(): void {
        if (AuthService.user && AuthService.user.firstName && AuthService.user.lastName) {
            this.userIsAuthed = true;
            this.usersName = `${AuthService.user.firstName} ${AuthService.user.lastName}`;
            let userBusinessFunctions = AuthService.user.businessFunctions;
            this.businessFunctions = userBusinessFunctions.sort((o1, o2) => {
                if (o1.displayName > o2.displayName) {
                    return 1;
                }
                if (o1.displayName < o2.displayName) {
                    return -1;
                }
                return 0;
            });
        } else {
            this.router.navigate(["splash"]);
        }
    }

    signOutClicked(): void {
        this.authService.logOut = true;
        this.toastr.success("Logged out successfully");
        this.router.navigate(["defaultroute/signedout"]);
    }

    /**
     * Checks if the user is logged in. Returns true or false
     */
    loggedIn(): boolean {
        return AuthService.businessFunction != null;
    }

    /**
     * Called when a business function is selected, redirects to appropriate one
     * @param selectedFunction The selected business function
     */
    editClicked(selectedFunction: IBusinessFunction): void {
        this.authService.businessFunction = selectedFunction;
        this.appUserService.getUser()
            .pipe(takeUntil(this.destroy$))
            .subscribe((user: IUser) => {
                this.authService.user = user;
                this.authService.businessFunction = selectedFunction;
            });
        this.router.navigate(["/" + selectedFunction.defaultRoute]);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
